import React, { useState } from "react";
import { FaFacebook, FaLinkedin, FaTwitter } from "react-icons/fa";

const ContactModal = ({ closeModal }) => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setError("");
  };

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = formData;

    if (!name.trim() || !email.trim() || !message.trim()) {
      setError("All fields are required.");
      return;
    }

    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    // Success state
    setSubmitted(true);
    setError("");
    
    // Auto close after 2 seconds
    setTimeout(() => {
      closeModal();
    }, 2000);
  };

  return (
    <div className=" z-50 absolute left-0 top-0 min-h-screen w-full flex items-center justify-center bg-black bg-opacity-60">
      <form onSubmit={handleSubmit} className=" bg-[#FCEBE5] rounded-xl relative p-16 max-w-lg w-full mx-4">
        <div className="mb-6">
          <h1 className=" text-4xl text-[#495057]">Contact</h1>
          <p className=" text-[#ADB5BD] mt-1">
            Lorem Ipsum is simply dummy text of the printing
          </p>
        </div>

        {submitted ? (
          <div className="text-center py-10">
            <h3 className="text-2xl text-[#3E3E3E] font-semibold mb-2">Thank you!</h3>
            <p className="text-[#6D6D6D]">Your message has been successfully sent.</p>
          </div>
        ) : (
          <>
            {error && (
              <div className="text-red-500 text-sm mb-4 font-medium bg-red-50 p-2 rounded-lg border border-red-100">
                {error}
              </div>
            )}

            <div className=" bg-white rounded-lg px-4 py-2 flex items-center mt-4">
              <label htmlFor="name" className=" w-[30%] text-[#6D6D6D]">Name</label>
              <input
                id="name"
                name="name"
                type="text"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                className=" border-none px-2 py-1 w-[70%] focus:outline-none"
              />
            </div>

            <div className=" bg-white rounded-lg px-4 py-2 flex items-center mt-4">
              <label htmlFor="email" className=" w-[30%] text-[#6D6D6D]">Email</label>
              <input
                id="email"
                name="email"
                type="text"
                placeholder="Enter your e-mail address here"
                value={formData.email}
                onChange={handleChange}
                className=" border-none px-2 py-1 w-[70%] focus:outline-none"
              />
            </div>

            <div className=" bg-white rounded-lg px-4 py-2 flex items-center mt-4">
              <label htmlFor="message" className=" w-[30%] text-[#6D6D6D]">Message</label>
              <input
                id="message"
                name="message"
                type="text"
                placeholder="Wanna share something with us?"
                value={formData.message}
                onChange={handleChange}
                className=" border-none px-2 py-1 w-[70%] focus:outline-none"
              />
            </div>
            
            <div className=" mt-6 text-left flex items-center justify-end">
              <button type="submit" className="bg-black text-white px-10 py-2 rounded-2xl hover:bg-opacity-80 transition-colors">
                Submit
              </button>
            </div>
          </>
        )}

        <div className=" flex items-center justify-between mt-8 pt-4 border-t border-[#F5D8CE] text-sm text-[#6D6D6D]">
          <p>Need more info? hello@newzera.com </p>
          <div className=" flex items-center gap-3 text-lg cursor-pointer">
            <FaFacebook className="hover:text-black transition-colors" />
            <FaLinkedin className="hover:text-black transition-colors" />
            <FaTwitter className="hover:text-black transition-colors" />
          </div>
        </div>
        <div
          onClick={closeModal}
          className=" cursor-pointer text-2xl font-bold absolute top-4 right-4 text-[#8b8b8b] hover:text-black transition-colors"
        >
          X
        </div>
      </form>
    </div>
  );
};

export default ContactModal;